import { PaymentService } from '@app/_services/payment.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as master from '../../assets/master.json';
import { CommonUtility } from '@app/_modules/commonUtility';
import { environment } from '@environments/environment';
import { formatDate } from '@angular/common';

export interface masters {
 
  amount: number
}


@Component({ templateUrl: 'student-details.component.html' })
export class StudentDetailComponent implements OnInit {

  JSON;
  console;
  todayDate:Date;
  total:any = 0;
  @ViewChild('txnForm') txnForm: any;
    isgPay_url:any;
    submitBtnMsg:String;
    submitBtnMsgClass:String = 'wrappper';
    EncDataField:string;
    MerchantIdField:string;
    TransactionId:string;
    BankIdField:string;
    TerminalIdField:string;
    VersionField:string;
    feeTypeList:any;
    feeObj:any;
    feeTypeAmount:any;
    classList:any[]=[];
    classListObj:any[]=[];
    feeDetailsList:any[]=[];
    feeType:any;
    dataSource:any;
    studentType:String ;

    isRecordNotFound:boolean = false;
    form: FormGroup;
    tranxnForm : FormGroup;
    loading = false;
    submitted = false;
    registeras;
    json:any= master;
    res:any;
    masterData:any;
    billDate:any='';
    feeData:any;
    amount:any;
    createdDate:any;
    totalFee:any;
    totalDisabled:boolean=true;    dueDate:any;
    studentData:any;
    commonUtility:CommonUtility;
  
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,

        private paymentService: PaymentService
    ){
      this.JSON=JSON;
      this.isgPay_url = paymentService.isgPay_url;
      this.commonUtility = this.paymentService.commonUtility;
      this.masterData = master;
      console.log(" this.masterData : ")
      console.log(this.masterData);
      this.console = console;
     

      this.isgPay_url = paymentService.isgPay_url;
      this.res=this.router.getCurrentNavigation().extras.state

      if(this.router.getCurrentNavigation().extras.state === null || this.router.getCurrentNavigation().extras.state === undefined)
      {
        this.router.navigate(['/payment/get-student']);
      }
     if(!(this.res.message === "No Payment Found"))
     {
      this.studentData = this.res.studentData;
      this.feeData = this.res.feeData;
      this.dueDate = this.res.dueDate
      this.commonUtility = paymentService.commonUtility;
     }
     else
     {
      this.isRecordNotFound = true;
     }
   
    if(this.studentData.registrationNo !=null){
      this.studentData.registrationNo = this.studentData.registrationNo.split('-')[1];
        }    
     }
    
   ngOnInit() {
        this.registeras =1;
        this.form = this.formBuilder.group({
          // studentType: ["",Validators.required],
          // schoolBranch: ["",Validators.required],
          // studentClass: ["",Validators.required],
          // studentSection: ["",Validators.required],
          // registrationNo: ["",[Validators.required,Validators.pattern("^[A-Za-z0-9]+$")]],
          // studentName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
          // dob: ["",[Validators.required,Validators.pattern("^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\\d\\d$")]],
          // mobileNo: ["",[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]],
          // emailId: ["",[Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]],
          // fatherName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
          // reAdmissionFee: ["",Validators.pattern("^[0-9]*$")],
          // courseFee: ["",Validators.pattern("^[0-9]*$")],
          // hostelFee: ["",Validators.pattern("^[0-9]*$")],
          // transportationFee: ["",Validators.pattern("^[0-9]*$")],
          // uniformFee: ["",Validators.pattern("^[0-9]*$")],
          // examinationFee: ["",Validators.pattern("^[0-9]*$")],
          // latePaymemtFee: ["",Validators.pattern("^[0-9]*$")],
          // otherFee: ["",Validators.pattern("^[0-9]*$")],
          // otherFeeDetails: ["",Validators.pattern("^[0-9]*$")],
          // totalFee: [""],
             
        });
        this.tranxnForm = this.formBuilder.group({
          Version:[''],
          TerminalId: [''],
          BankId: [''],
          MerchantId: [''],
          EncData:[''],
          TransactionId:['']

               });

              }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }
   
    onStudentTypeChange(studDtls : any){
      this.studentType = studDtls.value;
      console.log("studDtls")
      console.log(studDtls);
      console.log("this.studentType")
      console.log(this.studentType)
    
      if(this.studentType =='EXISTING'){
        this.form.addControl('schoolBranch', this.formBuilder.control('',Validators.required));
        this.form.addControl('studentClass', this.formBuilder.control('',Validators.required));
        this.form.addControl('studentSection', this.formBuilder.control('',Validators.required));
        this.form.addControl('registrationNo', this.formBuilder.control('', [Validators.required,Validators.pattern("^[A-Za-z0-9]+$")]));
        this.form.addControl('studentName', this.formBuilder.control('', [Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
        this.form.addControl('dob', this.formBuilder.control('', [Validators.required,Validators.pattern("^[A-Za-z0-9]+$")]));
        this.form.addControl('fatherName', this.formBuilder.control('',[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
        this.form.addControl('mobileNo', this.formBuilder.control('',[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]));
        this.form.addControl('emailId', this.formBuilder.control('',[Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]));
        this.form.addControl('reAdmissionFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('courseFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('hostelFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('transportationFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('uniformFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('examinationFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('latePaymemtFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('otherFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        this.form.addControl('otherFeeDetails', this.formBuilder.control('',Validators.pattern("^[a-zA-Z ]+$")));
        this.form.addControl('totalFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
        
      }
      // else
      // if(this.studentType == 'EXISTING'){
      //   this.form.addControl('registrationNo', this.formBuilder.control('', [Validators.required, Validators.pattern("^[0-9]*$"),Validators.minLength(1)]));
      //   this.form.addControl('captcha', this.formBuilder.control('', Validators.required));
      //   this.Cap();
      // }
    
    }
    onSub():void {
      if((this.totalFee) == 0)
      {
        this.commonUtility.alertMsg('Total Fees Should Not be Zero , Please Enter Atleast One Fee Details','',false);
      }
      else{
        console.log("In Else");
        this.submitted = true;
        console.log("this.form");
        console.log(this.form);
        if (this.form.invalid) {
          console.log("Inside form");          
            return;
        }
        this.loading = true;

        var req={
          "studentType":this.form.controls.studentType,
          "schoolBranch": this.form.controls.schoolBranch.value.toString(),
          "studentClass": this.form.controls.studentClass.value.toString(),
          "studentSection": this.form.controls.studentSection.value.toString(),
          "registrationNo": this.form.controls.registrationNo.value.toString(),
          "studentName": this.form.controls.studentName.value.toString(),
          "dob": this.form.controls.dob.value.toString(),
          "mobileNo": this.form.controls.mobileNo.value.toString(),
          "emailId": this.form.controls.emailId.value.toString(),
          "fatherName": this.form.controls.fatherName.value.toString(),
          "reAdmissionFee": this.form.controls.reAdmissionFee.value.toString(),
          "courseFee": this.form.controls.courseFee.value.toString(),
          "hostelFee": this.form.controls.hostelFee.value.toString(),
          "transportationFee": this.form.controls.transportationFee.value.toString(),
          "uniformFee": this.form.controls.uniformFee.value.toString(),
          "examinationFee": this.form.controls.examinationFee.value.toString(),
          "latePaymemtFee": this.form.controls.latePaymemtFee.value.toString(),
          "otherFee": this.form.controls.otherFee.value.toString(),
          "otherFeeDetails": this.form.controls.otherFeeDetails.value.toString(),
          "totalFee": this.totalFee.toString(),
          "source" : "XAVIER", 
        }  
        console.log("Existing req---");
        console.log(req);
        this.paymentService.submitXavierDetails(req).subscribe(res=>{

       if(res.body.statusCode === "00000")
       {
  
        this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
        this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
        this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
        this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
        this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
        this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

        this.EncDataField  	= res.body.data.fields.EncData;
        this.MerchantIdField = res.body.data.fields.MerchantId;
        this.BankIdField = res.body.data.fields.BankId;
        this.TerminalIdField = res.body.data.fields.TerminalId ;
        this.VersionField = res.body.data.fields.Version ;
        this.txnForm.nativeElement.submit();


       }
       else{
        this.commonUtility.alertMsg('Please try again Failed to submit data'+res.body.statusDesc,'',false);
       }
        this.loading = false;
      },
      (error)=>{

        this.commonUtility.alertMsg('Please try again Failed to submit data','',false);
          //this.router.navigate([''])
          this.loading = false;
        });
      }
    }

   
   hideError(controlName:any)
   {
     this.form.controls[controlName].markAsUntouched();
     if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
     {  this.submitBtnMsgClass="wrapper"; }
     if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
     { this.submitBtnMsg=""; }

   }

   redirectHome()
   {
     this.router.navigate(['/']);
   }
   getTotalFee() {
    this.totalFee
    let reAdmissionFee = this.form.get('reAdmissionFee').value;
    let courseFee = this.form.get('courseFee').value;
    let hostelFee = this.form.get('hostelFee').value;
    let transportationFee = this.form.get('transportationFee').value;
    let uniformFee = this.form.get('uniformFee').value;
    let examinationFee = this.form.get('examinationFee').value;
    let latePaymemtFee = this.form.get('latePaymemtFee').value;
    let otherFee = this.form.get('otherFee').value;
    
  
    this.totalFee =0;
    if(reAdmissionFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(reAdmissionFee));
    }
    if(courseFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(courseFee));
    }
    if(hostelFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(hostelFee));
    }
    
    if(transportationFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(transportationFee));
    }

    if(uniformFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(uniformFee));
    }

    if(examinationFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(examinationFee));
    }

    if(latePaymemtFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(latePaymemtFee));
    }

    if(otherFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(otherFee));
    }
   
    console.log("number"+this.totalFee);
      if(Number(this.totalFee)>0) 
      { 
        this.totalDisabled=false;
      }
      // else if((this.total) == 0){
      //   this.commonUtility.alertMsg('Total Fees Should Not be Zero , Please Enter Atleast One Fee Details','',false);
      // }
      else{
        this.totalDisabled=true;
      }
  
      console.log(this.totalDisabled);
      this.form.updateValueAndValidity()
  
      this.form.controls.totalFee.setValue(this.totalFee);
      this.form.controls.totalFee.updateValueAndValidity();
  
  }
  

  }